import {Status} from '../../../../helpers/merge-box-status-calculator/stacks-merge-conflicts-and-rebase-section-status'
import type {StacksMergeConflictsAndRebaseSectionProps} from '../types'
import {ResolveConflictsButtonAndDialog} from './shared/ResolveConflictsButtonAndDialog'
import {MergeBoxSectionHeader} from '../../common/MergeBoxSectionHeader'
import {AlertIcon} from '../../common/AlertIcon'
import {useId} from 'react'

/**
 * Scenario: one or more downstack entries have merge conflicts. Points the viewer at the
 * command line to resolve them within the stack.
 */
export function DownstackMergeConflicts({status, stackMetadata}: StacksMergeConflictsAndRebaseSectionProps) {
  const headerId = useId()

  if (status !== Status.StackMergeConflicts) return null

  return (
    <section
      aria-label="Downstack merge conflicts"
      className="border-bottom borderColor-muted"
      aria-describedby={headerId}
    >
      <div className="d-flex flex-column width-full overflow-hidden">
        <MergeBoxSectionHeader
          headerId={headerId}
          icon={<AlertIcon />}
          title="This stack has conflicts that must be resolved"
          subtitle="Use the command line to resolve conflicts within the stack before continuing."
          rightSideContent={<ResolveConflictsButtonAndDialog stackNumber={stackMetadata?.number ?? 0} />}
        />
      </div>
    </section>
  )
}
